<!-- <div class="main"
     [ngStyle]="{'padding-right': showFilters ? '332px' : '0'}"> -->
<div class="feedback-container">

  <div class="view-misc-info">

    <div style="flex:auto;">
      <ng-container *ngIf="alumnos">
        <ng-container *ngIf="alumnos.length > 1; else alumnoLabel">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Seleccione alumno</mat-label>
            <mat-select placeholder="Alumno" (valueChange)="changeAlumno($event)" [value]="alumnoID">
              <mat-option [value]="-1">Todo el curso</mat-option>
              <mat-option *ngFor="let alumno of alumnos" [value]="alumno.id">{{alumno.apellidosNombres}}</mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
        <ng-template #alumnoLabel>
          <!-- <label>{{alumnos[0].nombresApellidos}}</label> -->
        </ng-template>
      </ng-container>
    </div>

    <div class="tools">

      <button mat-button color="primary" i18n="@@filtros" (click)="showFilters = !showFilters">
        <mat-icon>filter_list</mat-icon>
        <span class="hide-label">Filtros</span>
      </button>

      <!-- <button mat-button color="primary" i18n="@@busqueda" (click)="abrirBusqueda()">
        <mat-icon>search</mat-icon>
        <span class="hide-label">Buscar</span>
      </button> -->
    </div>

  </div>

  <div *ngIf="!loading; else throbber" class="feedback">
    <div class="feedback-main">
      <div *ngIf="isAlumno && alumno">
        <div class="userMenuChip">
          <mat-icon *ngIf="!alumno.imageUrl" class="userMenuChip__img">account_circle</mat-icon>
          <img *ngIf="alumno.imageUrl" #userPic src="{{alumno.imageUrl}}" class="userMenuChip__img">
          <div>
            <span class="userMenuChip__user">{{alumno.nombresApellidos}}</span>
            <span class="userMenuChip__otherInfo">{{alumno.eMail}}</span>
          </div>
        </div>
        <mat-divider style="margin: 32px 0;"></mat-divider>
      </div>
      <div *ngIf="isAlumno && comentarios.length > 0" style="padding: 0 0 24px;">
        <h3 class="mat-h2">Retroalimentaciones por evidencia</h3>
        <!-- <table mat-table [dataSource]="comentarios" class="full-width mat-elevation-z2">
          <ng-container matColumnDef="fecha">
            <th style="width: 15% " mat-header-cell *matHeaderCellDef> Fecha</th>
            <td style="width: 15%; vertical-align: text-top;" mat-cell *matCellDef="let element">
              {{element.comentario.fecha}}</td>

          </ng-container>
          <ng-container matColumnDef="evidencia">
            <th style="width: 25%" mat-header-cell *matHeaderCellDef> Evidencia</th>
            <td style="width: 25%; vertical-align: text-top;" mat-cell *matCellDef="let element">
              {{element.evidencia.nombre}}</td>
          </ng-container>
          <ng-container matColumnDef="comentario">
            <th style="width: 60%" mat-header-cell *matHeaderCellDef> Comentario</th>
            <td style="width: 60%; white-space: pre-wrap;" mat-cell *matCellDef="let element">
              <glm-comentarios [comentarios]="[element.comentario]" [allowCreate]="false"
                [origen]="'unidadeventoalumno'">
              </glm-comentarios>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table> -->
        <mat-card>
          <ng-container *ngFor="let element of comentarios">
            <ng-container *ngIf="element.evidencia">
              <p style="padding-top: 24px;"><span
                  style="text-transform: uppercase; font-size: 80%; opacity: .6;display: block;">{{element.comentario.fecha}}</span>
                {{element.evidencia ? element.evidencia.nombre : 'Evidencia'}}</p>
              <p>
                <glm-comentarios [comentarios]="[element.comentario]" [allowCreate]="false"
                  [origen]="'unidadeventoalumno'">
                </glm-comentarios>
              </p>
              <mat-divider class="hidden__last" style="padding-bottom: 24px;"></mat-divider>
            </ng-container>
          </ng-container>
        </mat-card>

      </div>
      <div style="padding: 0 0 24px;" *ngIf="ausencias">
        <h3 class="mat-h2">Ausencias y retardos</h3>
        <mat-card style="padding:0">
          <div class="flex-wrap">
            <div class="clases-previstas">
              <h2 style="font-size: 40px; padding:0; margin:0">{{clasesPrevistas}}</h2>
              <label style="padding:0; margin:0">
                <small>Clases previstas</small>
              </label>
            </div>
            <div class="inline-flex" style="flex-grow: 10">
              <div class="flex-wrap">
                <div class="inline-flex detalles-asistencia">
                  <p><strong>Tipo</strong></p>
                  <p><strong>Cantidad</strong></p>
                </div>
                <ng-container *ngFor="let nombreAusencia of nombresAusencias">
                  <div class="inline-flex detalles-asistencia" style="position: relative;" #detalleContenedor>
                    <p><strong>{{nombreAusencia}}</strong></p>
                    <ng-container *ngIf="getAusencia(nombreAusencia) > 0; else zero">
                      <button mat-icon-button *ngIf="isAlumno; else cursoTemplate"
                        (click)="openFecha(fechas); $event.stopPropagation();">{{getAusencia(nombreAusencia)}}
                      </button>
                      <ng-template #cursoTemplate>
                        <button mat-icon-button
                          (click)="getDetalleAsistencia(nombreAusencia, detalleContenedor, $event)">
                          {{getAusencia(nombreAusencia)}}
                        </button>
                      </ng-template>
                    </ng-container>
                    <div class="ausenciaDetalle closed mat-elevation-z4" #fechas>
                      <ul>
                        <li *ngFor="let fecha of getFechasAusencias(nombreAusencia)">
                          <small>{{fecha}}</small>
                        </li>
                      </ul>
                    </div>
                    <ng-template #zero>
                      <p>{{getAusencia(nombreAusencia)}}</p>
                    </ng-template>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </mat-card>
      </div>
      <div *ngIf="metas; else loading">
        <h3 class="mat-h2">Criterios de evaluación por evidencia</h3>
        <div>
          <mat-form-field class="full-width">
            <input matInput (keyup)="filtroTexto()" [(ngModel)]="textFiltro" placeholder="Palabra clave">
          </mat-form-field>
          <ng-container *ngIf="metas">
            <ng-container *ngFor="let meta of metas">
              <mat-card *ngIf="meta.showMe" style="margin-bottom: 16px;">
                <h3 class="mat-h3">
                  <mat-basic-chip style="margin-left: 0; margin-bottom: 0px;">{{meta.meta.codigo}}
                    -{{meta.meta.id}}</mat-basic-chip>
                  {{getDescripcionMeta(meta.meta)}}
                </h3>
                <div class="info">
                  <mat-chip-set>
                    <ng-container *ngFor="let periodoID of meta.periodoIds.slice().reverse()">
                      <mat-basic-chip>
                        Periodo {{getPeriodoLabel(periodoID)}}
                      </mat-basic-chip>
                    </ng-container>
                      <ng-container *ngFor="let unidadID of meta.unidadIds">
                        <mat-basic-chip *ngIf='!isAlumno || !alumno.isRolAlumno'>
                          <a [routerLink]="['/', 'estudio', 'unidad', unidadID]">
                            Unidad {{unidadID}}
                          </a>
                        </mat-basic-chip>
                        <mat-basic-chip *ngIf="isAlumno && alumno && alumno.isRolAlumno">
                          <a [routerLink]="['/', 'estudio', 'familia', 'alumno', alumnoID, 'unidad', unidadID]">
                            Unidad {{unidadID}}
                          </a>
                        </mat-basic-chip>
                      </ng-container>
                  </mat-chip-set>
                </div>
                <ng-container *ngFor="let criterio of meta.criterios">
                  <ng-container *ngIf="criterio.showMe">
                    <div>
                      <h3 class="mat-small">Criterio</h3>
                      <p class="mat-chip-frame" style="background: thistle; font-size: 16px">
                        {{criterio.criterio.nombre}}
                      </p>
                    </div>
                    <ng-container *ngIf="!isAlumno; else alumnoChart">
                      <div class="fechas_barras glm-frame-basic"
                        style="margin-top: 16px; background: rgba(30, 30, 30, .12)">
                        <div class=" ">
                          <ng-container *ngFor="let fecha of criterio.fechasDesc">
                            <div class="flex-wrap">
                              <ng-container *ngIf="evidenciaChecked(fecha)">
                                <div class="inline-flex" style="padding-right: 24px;">
                                  <!-- <h4 class="mat-small" style="margin-top:0;">Evidencia</h4> -->
                                  <a
                                    [routerLink]="['/', 'estudio', 'unidad', fecha.evidencia.unidadID,
                                  'retroalimentacion', 'evento', fecha.evidencia.unidadEventoID, 'materia', materiaID]">
                                    {{fecha.evidencia.nombre}}
                                  </a>
                                </div>
                                <div class="inline-flex" style="padding-right: 24px;">
                                  <!-- <h4 class="mat-small" style="margin-top:0;">Fecha</h4> -->
                                  <p class="medium-text">{{fecha.fechaLarga}}</p>
                                </div>
                              </ng-container>
                            </div>
                            <div *ngIf="fecha.evidencia.loadingData">
                              <mat-spinner diameter="35"></mat-spinner>
                            </div>
                            <div *ngIf="fecha.evidencia.studentsData">
                              <div class="flex-wrap" style="align-items: center;">
                                <h5 class="inline-flex">{{fecha.evidencia.studentsData.escala.nombre}}</h5>
                                <span class="spacer"></span>
                                <button mat-icon-button (click)="fecha.evidencia.studentsData = null;">
                                  <mat-icon>close</mat-icon>
                                </button>
                              </div>
                              <p>{{fecha.evidencia.studentsData.detalle}}</p>
                              <ul>
                                <li *ngFor="let student of fecha.evidencia.studentsData.alumnos">
                                  {{student.apellidosNombres}}
                                  <ng-container *ngFor="let unidadID of meta.unidadIds">
                                    <a [routerLink]="['/', 'estudio',
                                    'unidad', fecha.evidencia.unidadID, 'retroalimentacion', 'evento', fecha.evidencia.unidadEventoID
                                    ]">
                                      {{unidadID}}
                                    </a>
                                  </ng-container>
                                </li>
                              </ul>
                            </div>
                          </ng-container>
                        </div>
                        <ng-container *ngIf="!isAlumno">
                          <div class=" " style=" ">
                            <ng-container *ngIf="criterio.glmChartData">

                              <!-- 
                                <glm-bar-chart [data]="criterio.glmChartData.reverse()" [yLabelKey]="'fecha'"
                                [groupsKeys]="['P', 'NL', 'LP', 'L', 'LD']"
                                [colors]="['#CCC', '#CF2A27', '#F1C232', '#2B78E4', '#009E0F']"
                                (itemClick)="chartItemClick($event)"></glm-bar-chart>
                              -->

                            </ng-container>
                            <div class="flex-wrap" style="align-items: baseline;">
                              <div class="mat-small flex-wrap" style="align-items: center; margin: 0 4px;"><span
                                  class="indicador-logro destacado"></span><span>Logro destacado</span></div>
                              <div class="mat-small flex-wrap" style="align-items: center; margin: 0 4px;"><span
                                  class="indicador-logro logro"></span><span>Logro</span></div>
                              <div class="mat-small flex-wrap" style="align-items: center; margin: 0 4px;"><span
                                  class="indicador-logro parcial"></span><span>Logro parcial</span></div>
                              <div class="mat-small flex-wrap" style="align-items: center; margin: 0 4px;"><span
                                  class="indicador-logro no-logro"></span><span>No logro</span></div>
                              <div class="mat-small flex-wrap" style="align-items: center; margin: 0 4px;"><span
                                  class="indicador-logro pendiente"></span><span>Pendiente</span></div>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-template #alumnoChart>
                      <div class="glm-frame-basic fechas_barras"
                        style="margin-top: 16px; background: rgba(30, 30, 30, .12)">
                        <div class=" ">
                          <div class="flex-wrap">
                            <div class="inline-flex" style="padding-right: 24px;">
                              <h4 class="mat-small" style="margin-top:0;">Evidencia</h4>
                              <span class="spacer"></span>
                            </div>
                            <div class="inline-flex" style="padding-right: 24px;">
                              <h4 class="mat-small" style="margin-top:0;">Fecha</h4>
                            </div>
                          </div>
                          <ng-container *ngFor="let fecha of criterio.fechasDesc">
                            <ng-container *ngIf="evidenciaChecked(fecha)">
                              <div class="flex-wrap">
                                <div class="inline-flex" style="padding-right: 24px;">
                                  <!-- <h4 class="mat-small" style="margin-top:0;">Evidencia</h4> -->
                                  <a class="medium-text"
                                    [routerLink]="['/', 'estudio', 'autoevaluacion', 'eventoMateria', fecha.evidencia.unidadEventoMateriaID, 'alumno', alumnoID]">
                                    {{fecha.evidencia.nombre}}</a>
                                </div>
                                <div class="inline-flex" style="padding-right: 24px;">
                                  <!-- <h4 class="mat-small" style="margin-top:0;">Fecha</h4> -->
                                  <p class="medium-text">{{fecha.fechaLarga}}</p>
                                </div>
                              </div>
                            </ng-container>
                          </ng-container>
                        </div>
                        <div *ngIf="!alumno.isRolAlumno">
                          <div class="flex-wrap" style="align-items: baseline;">
                            <h4 class="mat-small" style="margin-top:0;">Nivel de logro</h4>
                          </div>
                          <ng-container *ngIf="criterio.glmChartData != null">
                            <!-- <glm-line-chart [data]="criterio.glmChartData"></glm-line-chart> -->
                          </ng-container>
                          <div class="flex-wrap" style="align-items: baseline;">
                            <div class="mat-small flex-wrap" style="align-items: center; margin: 0 4px;"><span
                                class="indicador-logro destacado"></span><span>Logro destacado</span></div>
                            <div class="mat-small flex-wrap" style="align-items: center; margin: 0 4px;"><span
                                class="indicador-logro logro"></span><span>Logro</span></div>
                            <div class="mat-small flex-wrap" style="align-items: center; margin: 0 4px;"><span
                                class="indicador-logro parcial"></span><span>Logro parcial</span></div>
                            <div class="mat-small flex-wrap" style="align-items: center; margin: 0 4px;"><span
                                class="indicador-logro no-logro"></span><span>No logro</span></div>
                            <div class="mat-small flex-wrap" style="align-items: center; margin: 0 4px;"><span
                                class="indicador-logro pendiente"></span><span>Pendiente</span></div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </ng-container>
                </ng-container>
              </mat-card>
            </ng-container>
          </ng-container>
        </div>
      </div>
      <ng-template #loading>
        <mat-spinner></mat-spinner>
      </ng-template>
    </div>
    <div class="feedback-filters" style=" " [hidden]="!showFilters">
      <h3 class="mat-h3">Filtros</h3>
      <!-- <ng-container *ngIf="alumnos">
        <ng-container *ngIf="alumnos.length > 1; else alumnoLabel">
          <mat-form-field class="full-width">
            <mat-select placeholder="Alumno" (valueChange)="changeAlumno($event)" [value]="alumnoID">
              <mat-option [value]="-1">Todo el curso</mat-option>
              <mat-option *ngFor="let alumno of alumnos" [value]="alumno.id">{{alumno.apellidosNombres}}</mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
        <ng-template #alumnoLabel> -->
      <!-- <label>{{alumnos[0].nombresApellidos}}</label> -->
      <!-- </ng-template>
      </ng-container> -->
      <div *ngIf="!isAlumno">
        <h3 class="mat-h3">Sexo</h3>
        <p>
          <mat-checkbox color="primary" (change)="filtroSexo('m', $event.checked)" checked="true">Alumnos</mat-checkbox>
        </p>
        <p>
          <mat-checkbox color="primary" (change)="filtroSexo('f', $event.checked)" checked="true">Alumnas</mat-checkbox>
        </p>
      </div>
      <div>
        <h3 class="mat-h3">Periodos</h3>
        <ng-container *ngIf="periodos">
          <p *ngFor="let currPeriodo of periodos.slice().reverse()">
            <mat-checkbox color="primary"
              (change)="currPeriodo.checked = $event.checked; filtroPeriodo(currPeriodo, $event.checked)"
              checked="true">
              Periodo {{currPeriodo.nombre}}</mat-checkbox>
          </p>
        </ng-container>
        <h3 class="mat-h3">Unidades</h3>
        <ng-container *ngIf="unidades">

          <ng-container *ngFor="let currUnidad of unidades">
            <p *ngIf="currUnidad.showMe">
              <mat-checkbox [matTooltip]="currUnidad.nombre" color="primary"
                (change)="currUnidad.checked = $event.checked; filtroUnidad();" [checked]="currUnidad.checked">
                {{(currUnidad.nombre.length > 30) ? (currUnidad.nombre | slice:0:30) + '...' : currUnidad.nombre}}
              </mat-checkbox>
            </p>
          </ng-container>
        </ng-container>
        <h3 class="mat-h3">Metas/criterios</h3>
        <ng-container *ngIf="metas">
          <div *ngFor="let meta of metas" style="margin-bottom: 5px;">
            <ng-container *ngIf="meta.showCheck">
              <mat-checkbox [checked]="meta.checked" color="primary"
                (change)="meta.checked = $event.checked; meta.showMe = $event.checked;">
                {{meta.meta.codigo}}-{{meta.meta.id}} {{getDescripcionMeta(meta.meta)}}
              </mat-checkbox>
              <div style="padding-left: 20px">
                <ng-container *ngFor="let criterio of meta.criterios">
                  <mat-checkbox [checked]="criterio.checked" color="primary"
                    (change)="criterio.checked = $event.checked; criterio.showMe = $event.checked">
                    {{criterio.criterio.nombre}}
                  </mat-checkbox>
                </ng-container>
              </div>
            </ng-container>
          </div>
        </ng-container>
        <h3 class="mat-h3">Evidencias</h3>
        <div *ngFor="let evidencia of evidencias">
          <mat-checkbox [checked]="evidencia.checked" color="primary"
            (change)="evidencia.checked = $event.checked; evidencia.showMe = $event.checked; updateChartData()">
            {{evidencia.nombre}}
          </mat-checkbox>
        </div>
        <p>
          <button mat-raised-button color="primary" (click)="showFilters = !showFilters" class="hide-show-opt">
            Cerrar
          </button>
        </p>
      </div>
    </div>
  </div>
  <ng-template #throbber>
    <mat-progress-bar mode="ideterminate"></mat-progress-bar>
  </ng-template>
</div>
